export const reverseString = (val = "") => {
  const reverseStr = val.length > 0 && val.split("").reverse().join("");
  return val;
};
